import Cookies from 'js-cookie';

export function getCurrency() {
  return Cookies.get('currency') || 'HKD';
}

export function setCurrency(currency) {
  return Cookies.set('currency', currency, {expires: 3650});
}
